// this is an autogenerated file from App/Account/Content/Settings/Content/Onboarding/NotificationTemplates/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_Onboarding_NotificationTemplates($location_ids: [uuid!]!) {
  result: onboarding_inputs_notification_templates(
    location_ids: $location_ids
  ) {
    ok
  }
}

`